import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { getLatestArticles } from '@/mocks/articles';

const latestArticles = getLatestArticles(6);

const features = [
  {
    icon: 'ri-global-line',
    title: '最新入口地址',
    description: '实时更新 http 91.com 官方入口地址，提供多重备用访问方式，确保用户随时稳定访问平台。',
  },
  {
    icon: 'ri-book-open-line',
    title: '详细使用教程',
    description: '从入门到进阶，覆盖注册、登录、功能使用等全方位教程，手把手教你玩转平台。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '常见问题解答',
    description: '整理用户最常遇到的问题，提供清晰明了的解决方案，让你不再为使用问题烦恼。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全访问指南',
    description: '提供安全访问建议和防骗指南，帮助用户识别钓鱼网站，保护账号和个人信息安全。',
  },
];

const faqs = [
  {
    question: 'http 91.com 最新官方入口是什么？',
    answer: 'http 91.com 最新官方入口地址即为 http 91.com。建议用户直接通过该地址访问，并收藏本页面以获取最新的入口地址更新信息。我们也会在"入门指南"栏目中及时更新备用入口地址。',
  },
  {
    question: '为什么有时候无法访问 http 91.com？',
    answer: '无法访问可能由多种原因导致：网络连接不稳定、浏览器缓存问题、DNS设置异常或本地网络限制等。建议依次尝试以下方案：清除浏览器缓存、更换网络环境、刷新DNS缓存、使用备用入口地址。详细排查步骤可参考"常见问题"栏目的相关文章。',
  },
  {
    question: 'http 91.com 是否需要注册账号？',
    answer: '浏览 http 91.com 的部分公开内容无需注册账号。但若要使用完整功能（如互动评论、个性化推荐、内容收藏等），则需要注册并登录账号。注册过程简单快捷，只需提供基本信息和有效邮箱即可完成。',
  },
  {
    question: 'http 91.com 平台有哪些核心功能？',
    answer: 'http 91.com 平台提供丰富的功能，主要包括：海量内容浏览与智能搜索、个性化内容推荐、互动社区（评论/点赞/分享）、个人中心管理（收藏/历史/设置）、移动端适配访问等。详细的功能介绍可访问"功能教程"栏目了解。',
  },
  {
    question: '如何确保访问的是真正的 http 91.com 官方网站？',
    answer: '请以以下几点判断：1）网址是否为 http 91.com；2）页面底部是否有备案信息；3）浏览器地址栏是否显示安全连接标识；4）通过本指南网站提供的链接访问。切勿点击来路不明的链接，谨防钓鱼网站。',
  },
  {
    question: '如何使用手机访问 http 91.com？',
    answer: '在手机浏览器（推荐Chrome或Safari）中直接输入 http 91.com 即可访问移动端适配页面。建议将网站添加到手机桌面，方便下次快速访问。移动端功能与PC端基本一致，且针对触控操作进行了优化。',
  },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'http 91.com 官方指南',
    url: 'https://www.91.com',
    description: '围绕 http 91.com 提供完整的访问指引、功能介绍与常见问题解答，帮助用户快速了解 http 91.com 的核心服务、安全访问方式及最新入口地址。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'http 91.com 官方指南',
    url: 'https://www.91.com',
    description: 'http 91.com 用户指南与访问教程平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer,
      },
    })),
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'http 91.com 官方入口与使用指南',
    description: '围绕 http 91.com 提供完整的访问指引、功能介绍与常见问题解答。',
    url: 'https://www.91.com',
    isPartOf: {
      '@type': 'WebSite',
      name: 'http 91.com 官方指南',
      url: 'https://www.91.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20technology%20background%20with%20warm%20orange%20and%20teal%20gradients%2C%20soft%20overlapping%20circles%20and%20flowing%20lines%2C%20modern%20minimalist%20style%2C%20clean%20composition%2C%20digital%20atmosphere%2C%20high%20quality%20abstract%20art%20with%20smooth%20color%20transitions%20and%20subtle%20glow%20effects%2C%20professional%20tech%20aesthetic&width=1800&height=900&seq=hero-bg-91com-2024&orientation=landscape"
            alt="http 91.com 官方指南"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <p className="text-primary-300 text-sm md:text-base font-medium mb-3 tracking-wider uppercase">
              http 91.com 官方使用指南
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
              http 91.com 官方入口<br className="md:hidden" />与使用指南
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
              提供最新官方入口地址、详细访问教程与完整功能介绍，帮助您快速上手 http 91.com 平台，畅享全部服务。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/getting-started"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                查看入门指南
              </Link>
              <Link
                to="/category/faq"
                className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-lg font-medium text-sm transition-colors border border-white/30 whitespace-nowrap cursor-pointer"
              >
                常见问题解答
              </Link>
            </div>
            <div className="mt-10 flex items-center justify-center gap-6 text-white/60">
              <div className="flex items-center gap-2 text-xs">
                <i className="ri-checkbox-circle-line text-sm"></i>
                <span>最新入口地址</span>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <i className="ri-checkbox-circle-line text-sm"></i>
                <span>详细使用教程</span>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <i className="ri-checkbox-circle-line text-sm"></i>
                <span>7×24 在线支持</span>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-primary-500 text-sm font-semibold mb-2 tracking-wide uppercase">平台特色</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                为什么选择 http 91.com
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                我们致力于为每一位用户提供最优质的在线服务体验
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {features.map((feat, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/60 rounded-xl p-6 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/30 group cursor-default"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className={`${feat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Access Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-accent-500 text-sm font-semibold mb-2 tracking-wide uppercase">最新入口</p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              http 91.com 最新官方入口地址
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mb-8">
              截至2024年8月，以下为 http 91.com 最新有效入口地址
            </p>
            <div className="bg-background-50 border-2 border-primary-200 rounded-2xl p-6 md:p-8 mb-6">
              <div className="flex items-center justify-center gap-3 mb-3">
                <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-xs text-green-600 font-medium">当前可用</span>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-4">
                http 91.com
              </p>
              <p className="text-sm text-foreground-500">
                请将以上地址输入浏览器地址栏访问，建议收藏本页以获取最新入口信息
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-accent-500 text-sm"></i>
                安全连接
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-accent-500 text-sm"></i>
                实时更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-link text-accent-500 text-sm"></i>
                多重备用
              </span>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-primary-500 text-sm font-semibold mb-2 tracking-wide uppercase">内容导航</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                浏览指南内容
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                按分类查找您需要的内容，快速定位目标信息
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 border border-background-200/60 rounded-xl p-6 transition-all duration-300 hover:border-accent-200 group cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{cat.name}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4">{cat.description}</p>
                  <span className="text-xs text-accent-600 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    浏览文章 <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
              <div>
                <p className="text-primary-500 text-sm font-semibold mb-2 tracking-wide uppercase">最新文章</p>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  热门指南与教程
                </h2>
              </div>
              <Link
                to="/category/getting-started"
                className="text-sm text-primary-500 font-medium flex items-center gap-1 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="bg-background-50 border border-background-200/60 rounded-xl p-6 transition-all duration-300 hover:border-primary-200 group cursor-pointer"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full font-medium">
                      {categories.find((c) => c.slug === article.categorySlug)?.name}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">{article.summary}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                    <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                      阅读全文 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-primary-500 text-sm font-semibold mb-2 tracking-wide uppercase">常见问题</p>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                关于 http 91.com 的常见问题
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">
                这里汇总了用户最常咨询的问题，帮助您快速找到答案
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {faqs.map((faq, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openFaq === idx ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-foreground-400"></i>
                    </div>
                  </button>
                  {openFaq === idx && (
                    <div className="px-5 pb-4">
                      <div className="border-t border-background-200/60 pt-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/category/faq"
                className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-300 text-primary-600 rounded-lg text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                查看更多问题 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
              准备好开始使用 http 91.com 了吗？
            </h2>
            <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
              从入门指南开始，跟随我们的教程一步步了解平台的全部功能，开启您的 http 91.com 之旅。
            </p>
            <Link
              to="/category/getting-started"
              className="inline-flex px-8 py-3 bg-white text-primary-600 rounded-lg font-semibold text-sm hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即开始学习
            </Link>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}